import type { BrandTokens } from "./types";

export const defaultBrand: BrandTokens = {
  primary: "#0f8f8e",
  secondary: "#0d3640",
  accent: "#f3b23a",
  background: "#f7f9fb",
  text: "#0b1f27",
  fontFamily: "\"Source Sans 3\", \"Segoe UI\", sans-serif",
  radius: 10
};
